import './styles.scss'

export const ArrowDownIcon = () => {
	return <span className='arrow-icons down' />
}

export const ArrowUpIcon = () => {
	return <span className='arrow-icons up' />
}
